export default "__VITE_PUBLIC_ASSET__e26ae818__"